import { render, staticRenderFns } from "./roam.vue?vue&type=template&id=b85d0962&scoped=true"
import script from "./roam.vue?vue&type=script&lang=js"
export * from "./roam.vue?vue&type=script&lang=js"
import style0 from "./roam.vue?vue&type=style&index=0&id=b85d0962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85d0962",
  null
  
)

export default component.exports